import {
  FormLabel,
  TextField,
  Typography,
  FormControl,
  type SxProps,
} from '@mui/material';
import { useState } from 'react';
import type React from 'react';

import type { FieldValidation } from './validation/fieldValidation';
import { InputErrorIcon } from './validation/inputErrorIcon';

export const FormTextField = ({
  size = 'medium',
  testId,
  title,
  dataTestId,
  validation,
  placeholder,
  value,
  onChange,
  sx,
}: {
  size?: 'small' | 'medium';
  testId?: string;
  title: React.ReactNode;
  dataTestId?: string;
  validation?: FieldValidation;
  placeholder: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps;
}) => {
  const [touched, setTouched] = useState(false);
  const hasError =
    touched && (validation ? !validation.validateInput(value) : false);

  return (
    <FormControl sx={{ width: '100%', ...sx }}>
      {title && (
        <FormLabel>
          <Typography variant='subtitle1'>{title}</Typography>
        </FormLabel>
      )}
      <TextField
        size={size}
        data-testid={testId}
        onBlur={() => setTouched(true)}
        error={hasError}
        sx={{
          '& .MuiInputBase-root': {
            paddingRight: hasError ? '4px' : '24px',
          },
        }}
        slotProps={{
          htmlInput: { ...(dataTestId ? { 'data-testid': dataTestId } : {}) },
          input: {
            endAdornment: hasError && (
              <InputErrorIcon errorMessage={validation?.errorMessage(value)} />
            ),
          },
        }}
        placeholder={placeholder}
        disabled={false}
        value={value}
        onChange={onChange}
      />
    </FormControl>
  );
};
